<div *ngIf="!showDomainInfo">
  <div *ngIf="!hasDomain" class="d-flex justify-content-center align-items-center py-5">
    <div class="container  row d-block p-0 px-2 pt-4">
      <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3">
        <app-search-domains-input (onSearchChangeMode)="onSearchChangeMode()"
                                  (onSingleSearch)="onSingleSearch()" [availableOtherOptions]="false"></app-search-domains-input>
      </div>
    </div>
  </div>

  <!--Search results-->
  <app-initiatives-search-result-container *ngIf="!showDomainInfo"></app-initiatives-search-result-container>

  <div *ngIf="hasDomain" class="justify-content-center align-items-center py-5">
    <div class="card text-center shadow-sm custom-card">
      <div class="card-body">
        <ng-container *ngIf="domain">
          <p class="fw-semibold mb-1 fs-4">
            {{ 'Tu dominio' | translate }}
            <img src="{{ '/images/hecho-en-mexico/logo-mx.svg' | blobstorage }}"
                 alt=".mx" height="22">
            {{ 'se encuentra disponible' | translate }}
          </p>
          <h2 class="fw-bold">{{ domain }}</h2>
          <p class="fs-4 fw-semibold mb-1">
            {{ 'Con vigencia de' | translate }} <span class="fw-bold fs-2">
              1 {{ 'año' | translate }}
            </span>
          </p>
          <div class="mt-2">
            <button id="searchAnotherButton" type="button" class="btn btn-primary btn-lg text-uppercase"
                    (click)="onSearchAgain()">
              {{ 'Buscar de nuevo' | translate }}
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showDomainInfo" class="justify-content-center align-items-center py-5">
  <div class="card text-center shadow-sm custom-card">
    <div class="card-body">
      <ng-container *ngIf="showDomainInfo; else noDomainMessage">
        <p class="fw-semibold mb-1 fs-4">
          {{ 'Tu dominio' | translate }}
          <img src="{{ '/images/hecho-en-mexico/logo-mx.svg' | blobstorage }}"
               alt=".mx" height="22">
          {{ 'se encuentra disponible' | translate }}
        </p>
        <h2 class="fw-bold">{{ domain }}</h2>
        <p class="fs-4 fw-semibold mb-1">
          {{ 'Con vigencia de' | translate }} <span class="fw-bold fs-2">
            1 {{ 'año' | translate }}
          </span>
        </p>
        <span class=" d-none custom-link">{{ 'Es el dominio que preseleccionaste' | translate }}</span>
      </ng-container>

      <ng-template #noDomainMessage>
        <h2 class="fw-bold">
          {{ 'necesitas un dominio para continuar.' | translate }}
        </h2>

      </ng-template>
    </div>
  </div>
</div>
